import ColinLim from "../Assets/ColinLim.png";
import * as React from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Card() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="card">
      <div>
        <img
          className="card-img-style"
          src={ColinLim}
          alt="judge picture"
        ></img>
      </div>

      <div className="card-text-style">
        <h2 className="card-name-style">Colin Lim</h2>
        <p className="card-sub-name-style">
          Chief Information Officer and Chief Data Officer, Ministry of Health
        </p>
        <br />

        <button className="readmore-button" onClick={handleOpen}>
          Read More
        </button>
        <Modal
          className="close-button"
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="popup-style">
            <CloseIcon className="close-icon" onClick={handleClose} />
            <h2>Colin Lim</h2>
            <h3>
              Chief Information Officer and Chief Data Officer, Ministry of
              Health
            </h3>

            <br />
            <p>
              Colin Lim is Chief Information Officer and Chief Data Officer at
              the Singapore Ministry of Health. He is also group director of the
              InfoComm, Technology and Data Group. Prior to joining the Ministry
              of Health, Mr Lim was the founder and chief executive of
              MobilityX, a startup that received funding from SMRT and Toyota
              Tsusho. His previous experience includes roles in the private
              sector at IBM UK and SMRT as well as public sector roles in the
              Singapore Administrative Service at the Ministries of Home
              Affairs, Manpower and Transport and the Land Transport Authority.
              Mr Lim graduated from the London School of Economics and Oxford
              University, and has attended the Singularity and Stanford
              executive programmes.
            </p>
          </div>
        </Modal>
      </div>

      <div></div>
    </div>
  );
}

export default Card;
